var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree"},[_c('trees',{ref:"tree",attrs:{"treedata":_vm.treeData},on:{"changeNode":_vm.changeNode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }